import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4efb78a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Let's talk", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Have any comments or need to reach out? Use the form below to send us a message. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text secondary mb-1" }, "Your email address", -1))
const _hoisted_5 = { class: "text secondary error mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text secondary mb-1" }, "Your questions and comments", -1))
const _hoisted_7 = { class: "text secondary error mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      class: _normalizeClass({ disabled: _ctx.loading })
    }, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
        class: _normalizeClass(["mb-1", { error: _ctx.emailError }]),
        placeholder: "albert.einstein@gence.io"
      }, null, 2), [
        [_vModelText, _ctx.email]
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.emailError), 1),
      _hoisted_6,
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inquiry) = $event)),
        name: "",
        rows: "10",
        class: _normalizeClass(["mb-1", { error: _ctx.inquiryError }]),
        placeholder: "Can multiplication of n by n matrices be done in O(n2) operations?"
      }, null, 2), [
        [_vModelText, _ctx.inquiry]
      ]),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.inquiryError), 1),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["stop"])),
        class: "primary"
      }, "Submit")
    ], 2)
  ]))
}